import { UserRoles } from '../enums';

export function isAuthenticatedUserVet(
    user: AuthenticatedUser | Record<string, never>,
): user is AuthenticatedVet {
    return (user as AuthenticatedVet).type === UserRoles.VET;
}
